module.exports = __webpack_public_path__ + "static/media/audioPlayer1.75c1201d.png";